import type {
  Session,
  SessionCategories,
} from '@daddytime/sessions';

export type { Session, SessionCategories };

/**
 * Test category appended only when `?enable_test_sessions=true` is in the
 * URL. Lives client-side because it depends on the browser's URL and is
 * only useful for E2E test runs. The real catalog comes from GET /sessions
 * — see SessionsContext.
 */
const testCategory: SessionCategories =
  typeof window !== 'undefined' &&
  new URLSearchParams(window.location.search).get('enable_test_sessions') ===
    'true'
    ? {
        'Test Sessions': [
          {
            id: 'test-session',
            title: 'Test Audio',
            icon: '🧪',
            description: 'Short test audio for automated testing.',
            audioFile: 'test-audio.mp3',
          },
          {
            id: 'test-session-no-audio',
            title: 'Test Voting',
            icon: '🗳️',
            description: 'Test session without audio for voting tests.',
          },
        ],
      }
    : {};

/**
 * Layer the test category onto a catalog fetched from the backend.
 */
export function withTestCategory(
  catalog: SessionCategories
): SessionCategories {
  return { ...testCategory, ...catalog };
}

export function findSessionById(
  catalog: SessionCategories,
  sessionId: string
): { session: Session; category: string } | null {
  for (const [category, sessions] of Object.entries(catalog)) {
    const session = sessions.find((s) => s.id === sessionId);
    if (session) {
      return { session, category };
    }
  }
  return null;
}
